module.exports = __webpack_public_path__ + "4526e1be66425dce20091cc0890945a8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/iconfont/iconfont.ttf?t=1531206818380
// module id = 329
// module chunks = 1